export const environment = {
  production: true,
  enableMockTools: false
};
